import React from 'react'
import "./Trucking.css"

const Trucking = () => {
    return (
        <div className="trucking">
            <h3 className="trucking-h3">Trucking</h3>
            <p className="p-trucking">
                940 air offers TL (truckload) and LTL (less-than-truckload) trucking services within the region. 
                We provide dedicated fleets with satellite trucking devices that guarantee safety and visibility of your shipment 24/7.
                We have experience of transporting hazardous, oversize and out of gauge shipments in the region. 
                We secure all permits with the relevant authorities prior to arrival of shipments to avoid delays.
                Our services are structured with your specific requirement as premise on engagement!!
            </p>
        </div>
    )
}

export default Trucking
